import {getOne, createOne, updateOne, deleteOne, getOneBy} from "./Api";

const MODULE = 'description';

export function getDescription(id) {
	return getOne(MODULE, id);
}

export function getDescriptionByCover(coverId) {
	return getOneBy(MODULE, 'fk_cover', coverId);
}

export function getDescriptionByByPropertyAndId(property, id) {
	return getOneBy(MODULE, property, id);
}

export function createDescription(data) {
	return createOne(MODULE, data);
}

export function updateDescription(data) {
	return updateOne(MODULE, data);
}

export function deleteDescription(id) {
	return deleteOne(MODULE, id);
}
